import { getAPIURL } from "./utils";
import { withActiveToken } from "../lib/auth";
import { fetchProtected } from "./utils";

export const uploadFile = async (file, callback, onError, activeBusiness, router) => {
    withActiveToken(
        async () => {
            try {
                const apiURL = getAPIURL(`businesses/${activeBusiness?.uuid}/files/`);

                const response = await fetch(apiURL, {
                    method: "POST",
                    credentials: "include",
                    headers: {

                    },
                    body: file,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    onError?.(errorData);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                callback?.(data);
            } catch (error) {
                console.error("Error during file upload:", error);
                onError?.(error);
                throw error;
            }
        },
        router
    );
};

export const fetchFiles = async (callback, onError, activeBusiness, router, path) => {
    withActiveToken(
        async () => {
            try {
                const apiURL = getAPIURL(`businesses/${activeBusiness?.uuid}/files/${path ? `${path}` : ''}`);

                const response = await fetch(apiURL, {
                    method: "GET",
                    credentials: "include",
                    headers: {

                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    onError?.(errorData);
                    // throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                callback?.(data);
            } catch (error) {
                console.error("Error during file upload:", error);
                onError?.(error);
                // throw error;
            }
        },
        router
    );
}

export const updateFile = async (fileId, fileUpdate, callback, onError, activeBusiness, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "PATCH",
                `businesses/${activeBusiness?.uuid}/files/${fileId}/`,
                fileUpdate
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
}

export const deleteFile = async (fileId, callback, onError, activeBusiness, router) => {
    withActiveToken(
        async () => {
            try {
                const apiURL = getAPIURL(`businesses/${activeBusiness?.uuid}/files/${fileId}/`);

                const response = await fetch(apiURL, {
                    method: "DELETE",
                    credentials: "include",
                    headers: {

                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    onError?.(errorData);
                    // throw new Error(`HTTP error! status: ${response.status}`);
                }

                callback?.();
            } catch (error) {
                console.error("Error during file deletion:", error);
                onError?.(error);
                // throw error;
            }
        },
        router
    );
}

export const renderRecentFiles = async (callback, activeBusiness, onError, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "GET",
                `businesses/${activeBusiness?.uuid}/file_view_histories/`
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
};

export const addRecentfiles = async (fileId, callback, activeBusiness, onError, router) => {
    withActiveToken(
        async () => {
            try {
                const apiURL = getAPIURL(`businesses/${activeBusiness?.uuid}/file_view_histories/`,);

                const response = await fetch(apiURL, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ file: fileId }),
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    onError?.(errorData);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                callback?.(data);
            } catch (error) {
                console.error("Error during file upload:", error);
                onError?.(error);
                throw error;
            }
        },
        router
    );
};

export const onCreateFolder = async (folder, callback, activeBusiness, onError, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "POST",
                `businesses/${activeBusiness?.uuid}/paths/`,
                folder
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
};

export const onRenderFolders = async (callback, activeBusiness, onError, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "GET",
                `businesses/${activeBusiness?.uuid}/paths/`
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
};

export const updateFolder = async (pathId, folderUpdate, callback, onError, activeBusiness, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "PATCH",
                `businesses/${activeBusiness?.uuid}/paths/${pathId}/`,
                folderUpdate
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
}

export const deleteFolder = async (pathId, callback, onError, activeBusiness, router) => {
    withActiveToken(
        fetchProtected(
            "DELETE",
            `businesses/${activeBusiness?.uuid}/paths/${pathId}/`
        ).then((res) => {
            if (res.ok) {
                return res.json().then((json) => {
                    callback?.(json);
                });
            }
            return res.json().then((json) => {
                onError?.(json);
                return Promise.reject(json);
            });
        }),
        router
    );
}

export const getFileIndividualPermissions = async (fileId, callback, activeBusiness, onError, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "GET",
                `businesses/${activeBusiness?.uuid}/files/${fileId}/individual_permissions/`
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
}

export const updateFileIndividualPermissions = async (fileId, permissionsUpdate, callback, onError, activeBusiness, router) => {
    withActiveToken(
        () => {
            fetchProtected(
                "POST",
                `businesses/${activeBusiness?.uuid}/files/${fileId}/individual-permissions/`,
                permissionsUpdate
            ).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
        },
        router
    );
}